import { render, staticRenderFns } from "./top-paintings.vue?vue&type=template&id=4fe23019&scoped=true"
import script from "./top-paintings.vue?vue&type=script&lang=ts"
export * from "./top-paintings.vue?vue&type=script&lang=ts"
import style0 from "./top-paintings.vue?vue&type=style&index=0&id=4fe23019&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe23019",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BuyPainting: require('/web/components/buy/BuyPainting.vue').default})
